import type { IntegrationItemDto } from '@fos/shared/contracts/integrations';
import { INTEGRATION_KIND_LABELS, INTEGRATION_STATUS_LABELS, integrationProviderLabel } from '@fos/shared/labels';
import type { DelegateTarget } from '../../agents/components/DelegateToClaudeDialog';

/**
 * „Zleć Claude” przy błędzie integracji (Fala 9, DECISIONS 2026-10-07 „Zmiany w kodzie i operacje robi tylko Claude”).
 * Fravity OS nie ma widoku stanu zadań w tle (martwe wpisy outboxu widać w `npm run admin -- outbox-status`), więc
 * sprawy operacyjne zlecamy z miejsca, gdzie błąd jest widoczny: Ustawienia → Integracje. Zlecenie wewnętrzne (bez
 * klienta i projektu) — wykonawca domyślnie sesja Claude przez MCP. Claude nie dostaje ani nie wpisuje sekretów.
 */
export function integrationNeedsClaude(item: IntegrationItemDto): boolean {
  return item.id !== null && (item.status === 'error' || item.status === 'auth_lost');
}

export function integrationDelegation(item: IntegrationItemDto): DelegateTarget {
  const kind = INTEGRATION_KIND_LABELS[item.kind];
  const provider = item.provider ? integrationProviderLabel(item.provider) : null;
  const lines = [
    `Integracja „${kind}”${provider ? ` (${provider})` : ''} w Fravity OS zgłasza problem: ${INTEGRATION_STATUS_LABELS[item.status]}.`,
    item.lastError ? `Ostatni błąd: ${item.lastError}` : null,
    item.lastSyncAt ? `Ostatnia udana synchronizacja: ${item.lastSyncAt}.` : null,
    '',
    'Sprawdź logi API i workera (zadania w tle; martwe wpisy: npm run admin -- outbox-status), konfigurację integracji i połączenie z dostawcą. Ustal przyczynę, napraw to, co leży po stronie kodu albo serwera, i opisz wynik.',
    'Nie wpisuj i nie zmieniaj haseł, kluczy API ani tajnych adresów — jeśli trzeba je zmienić, napisz to w podsumowaniu (wpisuje je osoba w Ustawienia → Integracje).',
  ];
  return {
    contextLabel: `Integracja: ${kind}`,
    title: `Błąd integracji: ${kind}`.slice(0, 200),
    instruction: lines.filter((l) => l !== null).join('\n'),
  };
}
